// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file reaction/reaction_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file reaction/reaction_model.proto.
 */
export const file_reaction_reaction_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch1yZWFjdGlvbi9yZWFjdGlvbl9tb2RlbC5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiYAoIUmVhY3Rpb24SCgoCaWQYASABKAMSDQoFdGl0bGUYAiABKAkSFAoMYW5pbWF0aW9uVXJsGAMgASgJEhIKCnByZXZpZXdVUkwYBCABKAkSDwoHdW5pY29kZRgFIAEoCUIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM'
  );

/**
 * @generated from message com.gem.bff.contract.Reaction
 */
export type Reaction = Message<'com.gem.bff.contract.Reaction'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string animationUrl = 3;
   */
  animationUrl: string;

  /**
   * @generated from field: string previewURL = 4;
   */
  previewURL: string;

  /**
   * @generated from field: string unicode = 5;
   */
  unicode: string;
};

/**
 * Describes the message com.gem.bff.contract.Reaction.
 * Use `create(ReactionSchema)` to create a new message.
 */
export const ReactionSchema: GenMessage<Reaction> =
  /*@__PURE__*/
  messageDesc(file_reaction_reaction_model, 0);
